<template>
  <div class="form-container">

    <!-- Nova Questão: Água -->
    <div class="question-group">
      <label class="required">Água Mineral:</label>
      <div class="checkbox-group">
        <label v-for="(agua, index) in aguas" :key="index">
              <input 
              type="radio"
              name="agua" 
              v-model="cardapio.agua" 
              :value="agua" 
              :onchange="emitirCardapio"/> {{  agua }}
        </label>
      </div>
    </div>
    <div class="itens-selecionados">
      Água selecionada: {{ cardapio.agua }}
    </div>

    <!-- Nova Questão: Café -->
    <div class="question-group">
      <label class="required">Café Sem Açúcar:</label>
      <div class="checkbox-group">
        <label v-for="(cafe, index) in cafes" :key="index">
              <input 
              type="radio"
              name="cafe" 
              v-model="cardapio.cafe" 
              :value=" cafe" 
              :onchange="emitirCardapio"/> {{  cafe }}
        </label>
      </div>
      <div class="instrucoes">
        adoçante e açúcar a parte
      </div>
    </div>
    <div class="itens-selecionados">
      Café: {{ cardapio.cafe }}
    </div>

    <!-- Questão do Suco -->
     <br />
    <div class="question-group">
      <label class="required">Nectar de Frutas:</label>
      <div class="checkbox-group">
        <label v-for="(suco, index) in sucos" :key="index">
              <input 
              type="checkbox" 
              name="sucos"
              :disabled="cardapio.sucos.length >= 2 && !cardapio.sucos.includes(suco)" 
              v-model="cardapio.sucos" 
              :value="suco" 
              @change="handleSucosClick"/> {{ suco }}
        </label>
      </div>
      <div class="instrucoes">
        (2 opções)
      </div>
    </div>
    <div class="itens-selecionados">
      Suco(s) selecionado(s): {{ cardapio.sucos.join(', ') }}
    </div>

    <!-- Nova Questão: Chá -->
    <div class="question-group">
      <label class="required">Chá Matte:</label>
      <div class="checkbox-group">
        <label v-for="(c, index) in cha" :key="index">
              <input 
              type="radio"
              name="cha" 
              v-model="cardapio.cha" 
              :value="c" 
              :onchange="emitirCardapio"/> {{  c }}
        </label>
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>      
    </div>
    <div class="itens-selecionados">
      Chá selecionado: {{ cardapio.cha }}
    </div>

    <!-- Nova Questão: Finger Food -->
    <div class="question-group">
      <label class="required">Finger Food:</label>
      <div class="checkbox-group">
          <label v-for="(ff, index) in fingerFoods" :key="index">
              <input 
              type="checkbox" 
              :disabled="cardapio.fingerFoods.length >= 2 && !cardapio.fingerFoods.includes(ff)" 
              v-model="cardapio.fingerFoods" 
              :value="ff" 
              :onchange="emitirCardapio" /> {{ ff }}
        </label>           
      </div>
      <div class="instrucoes">
        (2 opções)
      </div>
    </div>
    <div class="itens-selecionados">
      Finger Foods selecionados: 
      <span v-if="cardapio.fingerFoods.length > 0">
        {{ cardapio.fingerFoods.join(', ') }}
      </span>
    </div>


    <!-- Nova Questão: Caldos e Sopas -->
    <div class="question-group">
      <label class="required">Caldos e Sopas:</label>
      <div class="checkbox-group">
          <label v-for="(caldosSopa, index) in caldosSopas" :key="index">
              <input 
              type="checkbox" 
              :disabled="cardapio.caldosSopas.length >= 2 && !cardapio.caldosSopas.includes(caldosSopa)" 
              v-model="cardapio.caldosSopas" 
              :value="caldosSopa" 
              :onchange="emitirCardapio" /> {{ caldosSopa }}
        </label>           
      </div>
      <div class="instrucoes">
        (2 opções)
      </div>
    </div>
    <div class="itens-selecionados">
      Caldos e Sopas selecionados: 
      <span v-if="cardapio.caldosSopas.length > 0">
        {{ cardapio.caldosSopas.join(', ') }}
      </span>
    </div>

    <!-- Nova Questão: Salada -->
    <div class="question-group">
      <label class="required">Saladas </label>
      <div class="checkbox-group">
          <label v-for="(salada, index) in saladas" :key="index">
              <input type="radio" name="salada" v-model="cardapio.salada" :value="salada" :onchange="emitirCardapio"/>
              {{ salada }}
          </label>           
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Salada selecionada: 
      <span>
        {{ cardapio.salada }}
      </span>
    </div>

        <!-- Nova Questão: Torradas -->
    <div class="question-group">
      <label class="required">Torradas:</label>
      <div class="checkbox-group">
        <label v-for="(torrada, index) in torradas" :key="index">
              <input 
              type="radio"
              name="torrada" 
              v-model="cardapio.torrada" 
              :value="torrada" 
              :onchange="emitirCardapio"/> {{  torrada }}
        </label>
      </div>
    </div>
    <div class="itens-selecionados">
      Torradas: {{ cardapio.torrada }}
    </div>

    <!-- Nova Questão: Patês -->
    <div class="question-group">
      <label class="required">Patês</label>
      <div class="checkbox-group">
          <label v-for="(pate, index) in pates" :key="index">
           <input 
              type="checkbox" 
              :disabled="cardapio.pates.length >= 2 && !cardapio.pates.includes(pate)" 
              v-model="cardapio.pates" 
              :value="pate" 
              :onchange="emitirCardapio" /> {{ pate }}

        </label>           
      </div>
      <div class="instrucoes">
        (2 opções)
      </div>
    </div>
    <div class="itens-selecionados">
      Patê(s) selecionado(s): 
      <span>
        {{ cardapio.pates.join(', ') }}
      </span>
    </div>

    <!-- Nova Questão: Doces -->
    <div class="question-group">
      <label class="required">Doces Individuais</label>
      <div class="checkbox-group">
          <label v-for="(doce, index) in doces" :key="index">
           <input 
              type="checkbox" 
              :disabled="cardapio.doces.length >= 2 && !cardapio.doces.includes(doce)" 
              v-model="cardapio.doces" 
              :value="doce" 
              :onchange="emitirCardapio" /> {{ doce }}

        </label>           
      </div>
      <div class="instrucoes">
        (2 opções)
      </div>
    </div>
    <div class="itens-selecionados">
      Doce(s) selecionado(s): 
      <span>
        {{ cardapio.doces.join(', ') }}
      </span>
    </div>

    <!-- Nova Questão: Salada de Frutas -->
    <div class="question-group">
      <label class="required">Salada de Frutas:</label>
      <div class="checkbox-group">
          <label v-for="(fruta, index) in frutas" :key="index">
              <input 
              type="checkbox" 
              :disabled="cardapio.frutas.length >= 4 && !cardapio.frutas.includes(fruta)" 
              v-model="cardapio.frutas" 
              :value="fruta" 
              :onchange="emitirCardapio" /> {{ fruta }}
        </label>           
      </div>
      <div class="instrucoes">
        (4 opções)
      </div>
    </div>
    <div class="itens-selecionados">
      Fruta(s) selecionada(s): 
      <span v-if="cardapio.frutas.length > 0">
        {{ cardapio.frutas.join(', ') }}
      </span>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    tipoCardapio: {
      type: Number,
      default: null
    },
  },
  data() {
    return {

      doces:[
        'Mini Tartelete com Creme de Confeiteiro com Morangos',
        'Mini Tartelete com Creme de Confeiteiro com Raspas de Limão ou Mousse de Limão',
        'Mini Tartelete com Creme de Confeiteiro com Frutas Amarelas (Manga, Pêssego, Damasco)',
        'Mini Brownie (30g)',
      ],

      bolos: [
        'Cenoura com Cobertura de Chocolate',
        'Chocolate com Cobertura de Chocolate',
        'Fubá com Cobertura de Goiabada',
        'Bolo de Maçã com Especiarias e Cobertura de Fondant',
        'Bolo de Iogurte com Cobertura de Geleia de Frutas Vermelhas ou Morangos',
      ],

      fingerFoods: [
        'Polenta com Ragu de Carne',
        'Polenta com Ragu de Cogumelos',
        'Escondidinho de Carne',
        'Escondidinho de Frango',
        'Ravioli/Capeletti de Carne ao Molho Sugo',
        'Ravioli/Capeletti de Frango ao Molho Sugo',
        'Ravioli/Capeletti de Queijo ao Molho Sugo',
        'Cuscuz Paulista',
        'Risoto de Limão Siciliano',
        'Risoto de Alho Poró',
      ],

      caldosSopas: [
        'Feijão com Crispy de Bacon', 
        'Mandioca com Frango Desfiado', 
        'Abóbora com Queijo Muçarela', 
        'Mandioquinha com Crispy de Couve Manteiga',
        'Caldo Verde com Crispy de Bacon', 
        'Vichysoisse (Batata e Alho Poró) com Crispy de Alho Poró', 
        'Creme de Couve Flor com Alho Crocante'
      ],

      saladas: [
        'Verrine com Cenoura Ralada, Beterraba Ralada e Alface em Tiras ou Rasgada e Molho de Salada', 
        'Verrine com Rúcula em Tiras ou Rasgada, Tomate Picado, Queijo Branco e Manjericão', 
        'Verrine com Grão de Bico, Tomate, Cebola Roxa, Azeitona Verde, Salsinha e Cebolinha'
      ],


      pates: [
        'Alho',
        'Berinjela',
        'Azeitona',
        'Queijo',
      ],


      cha: [
        'Quente com limão',
        'Quente sem limão',
        'Frio com limão',
        'Frio sem limão',
        'Não',
      ],

      aguas: [
        'Sim',
        'Não',
      ],

      torradas: [
        'Sim',
        'Não',
      ],

      cafes: [
        'Sim',
        'Não',
      ],

      sucos: [
        'Abacaxi',
        'Laranja',
        'Pêssego',
        'Goiaba',
        'Uva',
        'Manga',
        'Caju',
        'Maracujá',
      ],

      frutas: [
        'Abacaxi',
        'Manga',
        'Maçã',
        'Melão',
        'Morango',
        'Uva',
      ],

      cardapio: {
        tipoCardapio: null,
        sucos: [],
        agua: '', 
        cafe: '',
        cha: '',
        fingerFoods: [],
        caldosSopas: [],
        torrada: '',
        pates: [],
        doces: [],
        frutas: []
      },
    };
  },

  methods: {

    resetCardapio(){

      this.cardapio = {
        tipoCardapio: null,
        sucos: [],
        agua: '', 
        cafe: '',
        cha: '',
        fingerFoods: [],
        caldosSopas: [],
        torrada: '',
        pates: [],
        doces: [],
        frutas: []
      }
    },

    emitirCardapio() {
      this.$emit('atualizar-cardapio', this.cardapio);
    }

  },

  created(){

  },

  mounted() {
    this.resetCardapio();
  },

  computed: {

  }
};
</script>
  
<style src="../css/buffet.css"></style>

